"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineStatus = void 0;
var MachineStatus;
(function (MachineStatus) {
    MachineStatus["Online"] = "ONLINE";
    MachineStatus["Offline"] = "OFFLINE";
})(MachineStatus || (exports.MachineStatus = MachineStatus = {}));
